import React from 'react';

import PropTypes from 'prop-types';

import BaseIcon from './BaseIcon';

const iconPropTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
};

function AC(props) {
    return (
        <BaseIcon viewBox="0 0 16 16" {...props}>
            <title>{props.title || 'Air Conditioning'}</title>
            <g>
                <polygon points="14 8 11.21 8 13.36 5.86 12.65 5.15 9.8 8 8 8 8 6.21 10.85 3.35 10.15 2.65 8 4.79 8 2 7 2 7 4.79 4.85 2.65 4.15 3.35 7 6.21 7 8 5.2 8 2.35 5.15 1.65 5.86 3.79 8 1 8 1 9 3.79 9 1.65 11.15 2.35 11.85 5.21 9 7 9 7 10.8 4.15 13.65 4.85 14.36 7 12.21 7 15 8 15 8 12.21 10.15 14.36 10.85 13.65 8 10.8 8 9 9.79 9 12.65 11.85 13.36 11.15 11.21 9 14 9 14 8" />
            </g>
        </BaseIcon>
    );
}

AC.propTypes = iconPropTypes;

function Attendant(props) {
    return (
        <BaseIcon viewBox="0 0 16 16" {...props}>
            <title>{props.title || 'Attendant'}</title>
            <g>
                <circle cx="4.5" cy="2.5" r="1.5" />
                <path d="M7,6.5A1.39,1.39,0,0,0,6.91,6,1.47,1.47,0,0,0,6,5.09,1.39,1.39,0,0,0,5.5,5h-2a1.39,1.39,0,0,0-.5.09A1.47,1.47,0,0,0,2.09,6,1.39,1.39,0,0,0,2,6.5V10H3v5H6V10h4V8H7Z" />
                <path d="M10,4A2,2,0,0,0,8,6V7h4V6A2,2,0,0,0,10,4Z" />
            </g>
        </BaseIcon>
    );
}

Attendant.propTypes = iconPropTypes;

function ExtraLegroom(props) {
    return (
        <BaseIcon viewBox="0 0 16 16" {...props}>
            <title>{props.title || 'Extra Legroom'}</title>
            <g>
                <path d="M12.68,12h0l-2-5h-4L4.93,2.63a1,1,0,1,0-1.86.74L5.32,9h4l1.2,3h0l.55,1.36A1,1,0,0,0,12,14h3V13Z" />
                <path d="M8.5,10H4.59L2.09,3.9l-.93.38,2.58,6.28a.7.7,0,0,0,.64.43H9V10Z" />
            </g>
        </BaseIcon>
    );
}

ExtraLegroom.propTypes = iconPropTypes;

function Games(props) {
    return (
        <BaseIcon viewBox="0 0 16 16" {...props}>
            <title>{props.title || 'Games'}</title>
            <g>
                <path d="M12.5,3h-9A3.5,3.5,0,0,0,0,6.5v5a2.5,2.5,0,0,0,4.81.94h0l1-2.44h4.34l1,2.44h0A2.5,2.5,0,0,0,16,11.5v-5A3.5,3.5,0,0,0,12.5,3ZM14,6.5A1.5,1.5,0,1,1,12.5,5,1.5,1.5,0,0,1,14,6.5ZM3.5,5A1.5,1.5,0,1,1,2,6.5,1.5,1.5,0,0,1,3.5,5Z" />
                <circle cx="12.5" cy="6.5" r="0.5" />
                <circle cx="3.5" cy="6.5" r="0.5" />
            </g>
        </BaseIcon>
    );
}

Games.propTypes = iconPropTypes;

function Green(props) {
    return (
        <BaseIcon viewBox="0 0 16 16" {...props}>
            <title>{props.title || 'Green'}</title>
            <g>
                <rect height="1.1" width="1.1" x="12.9" y="2" />
                <path d="M14,3.1a8.44,8.44,0,0,0-.07-1,8.45,8.45,0,0,0-1-.07h-.28A9.62,9.62,0,0,0,3,11.58L6.29,8.29,7,9,3.08,12.92,1.5,14.5l.71.71L4.42,13A9.62,9.62,0,0,0,14,3.38,2.53,2.53,0,0,0,14,3.1Z" />
            </g>
        </BaseIcon>
    );
}

Green.propTypes = iconPropTypes;

function HotBeverage(props) {
    return (
        <BaseIcon viewBox="0 0 16 16" {...props}>
            <title>{props.title || 'HotBeverage'}</title>
            <g>
                <path d="M14,5V4H7.71L4.86,1.15a.5.5,0,0,0-.71.71L6.29,4H2V5L7,9v2L4,13v1h8V13L9,11V9ZM9,5A1,1,0,1,1,8,6,1,1,0,0,1,9,5Z" />
            </g>
        </BaseIcon>
    );
}

HotBeverage.propTypes = iconPropTypes;

function LoyaltyRewards(props) {
    return (
        <BaseIcon viewBox="0 0 16 16" {...props}>
            <title>{props.title || 'Loyalty Rewards'}</title>
            <g>
                <path d="M1,4v9H15V4Zm9.27,8L8,10.44,5.73,12l.85-2.62L4.32,7.67h2.8L8,5l.88,2.67h2.8L9.42,9.38Z" />
            </g>
        </BaseIcon>
    );
}

LoyaltyRewards.propTypes = iconPropTypes;

function Meal(props) {
    return (
        <BaseIcon viewBox="0 0 16 16" {...props}>
            <title>{props.title || 'Meal'}</title>
            <g>
                <path d="M6,4H5V1H4V4H3V1H2V7A1,1,0,0,0,3,8v5.5a1.5,1.5,0,0,0,3,0V8A1,1,0,0,0,7,7V1H6Z" />
                <path d="M11,1A2,2,0,0,0,9,3v7h2v3.5a1.5,1.5,0,0,0,3,0V1Z" />
            </g>
        </BaseIcon>
    );
}

Meal.propTypes = iconPropTypes;

function Movies(props) {
    return (
        <BaseIcon viewBox="0 0 16 16" {...props}>
            <title>{props.title || 'Movies'}</title>
            <g>
                <path d="M15,12V3H1v9H7v1H5v1h6V13H9V12ZM6,9.67V5l4,2.33Z" />
            </g>
        </BaseIcon>
    );
}

Movies.propTypes = iconPropTypes;

function Newspaper(props) {
    return (
        <BaseIcon viewBox="0 0 16 16" {...props}>
            <title>{props.title || 'Newspaper'}</title>
            <g>
                <path d="M12,5V3H1v9.5A1.5,1.5,0,0,0,2.5,14h10A1.5,1.5,0,0,0,14,12.5V5Zm1,7.5a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5V4h9v7.5a.5.5,0,0,0,1,0V6h1Z" />
                <rect height="3" width="7" x="3" y="5" />
                <rect height="1" width="3" x="3" y="9" />
                <rect height="1" width="3" x="7" y="9" />
                <rect height="1" width="3" x="3" y="11" />
                <rect height="1" width="3" x="7" y="11" />
            </g>
        </BaseIcon>
    );
}

Newspaper.propTypes = iconPropTypes;

function PowerOutlet(props) {
    return (
        <BaseIcon viewBox="0 0 16 16" {...props}>
            <title>{props.title || 'Power Outlet'}</title>
            <g>
                <path d="M11,6V3A1,1,0,0,0,9,3V6H7V3A1,1,0,0,0,5,3V6H3V7a4,4,0,0,0,3,3.86V15h4V10.86A4,4,0,0,0,13,7V6Z" />
            </g>
        </BaseIcon>
    );
}

PowerOutlet.propTypes = iconPropTypes;

function QRCode(props) {
    return (
        <BaseIcon viewBox="0 0 24 24" {...props}>
            <title>{props.title || 'QR Boarding Code'}</title>
            <g>
                <path clipRule="evenodd" d="M10.2947 7.42109H10.2961V10.4117H2.00149V10.4114V7.42109V4.99064H2V2H10.2947V2.00034L10.2947 7.42109ZM4.9507 4.99064L7.34545 4.99064V7.42109H4.9507V4.99064ZM2.00149 21.7198V21.7199H4.9507V21.7198H7.34545V21.7199H10.2947V21.7198H10.2961V18.7292H10.2947V16.2995L10.2947 13.3088V13.3088H7.34545V13.3088H4.9507V13.3087H2.00149V13.3088H2V16.2995H2.00149V18.7292V21.7198ZM7.34545 16.2995V18.7292H4.9507V16.2995H7.34545ZM16.1027 13.3088H13.1535V16.2994H16.1027V19.0093H19.0518H19.0519H22.001V16.0187H19.0519H19.0518H16.1027V13.3088ZM16.1027 19.0094H13.1535V22H16.1027V19.0094ZM19.0518 19.0094H22.001V22H19.0518V19.0094ZM21.4481 10.4115L21.448 2.00034V2H13.1534V2.00006H13.1529V7.42093V10.4112V10.4116H21.4476V10.4115H21.4481ZM18.4988 4.99064L16.1021 4.99064V7.42093H18.4988V4.99064Z" fillRule="evenodd" />
            </g>
        </BaseIcon>
    );
}

QRCode.propTypes = iconPropTypes;

function Restroom(props) {
    return (
        <BaseIcon viewBox="0 0 16 16" {...props}>
            <title>{props.title || 'Restroom'}</title>
            <g>
                <circle cx="3.56" cy="2.5" r="1.5" />
                <circle cx="11.5" cy="2.5" r="1.5" />
                <path d="M4,5H3A2,2,0,0,0,1,7v3H2v4a1,1,0,0,0,1,1H4a1,1,0,0,0,1-1V10H6V7A2,2,0,0,0,4,5Z" />
                <path d="M15,11,13.23,5.68A1,1,0,0,0,12.28,5H10.72a1,1,0,0,0-.95.68L8,11v1h2v2a1,1,0,0,0,1,1h1a1,1,0,0,0,1-1V12h2Z" />
            </g>
        </BaseIcon>
    );
}

Restroom.propTypes = iconPropTypes;

function SatelliteTV(props) {
    return (
        <BaseIcon viewBox="0 0 16 16" {...props}>
            <title>{props.title || 'Satellite TV'}</title>
            <g>
                <path d="M7.56,9.86,8.71,8.71A1,1,0,1,0,7.29,7.29L6.14,8.44,3,5.28l0,0-.35.35A3.8,3.8,0,0,0,2.28,6,5.49,5.49,0,0,0,10,13.72a3.8,3.8,0,0,0,.37-.33l.35-.35,0,0Z" />
                <path d="M8,4V6a2,2,0,0,1,2,2h2A4,4,0,0,0,8,4Z" />
                <path d="M8,1V3a5,5,0,0,1,5,5h2A7,7,0,0,0,8,1Z" />
            </g>
        </BaseIcon>
    );
}

SatelliteTV.propTypes = iconPropTypes;

function Seatbelts(props) {
    return (
        <BaseIcon viewBox="0 0 16 16" {...props}>
            <title>{props.title || 'Seatbelts'}</title>
            <g>
                <polygon points="6 3 11 11 8 11 3 3 6 3" />
                <rect height="2" width="11" x="3" y="11" />
            </g>
        </BaseIcon>
    );
}

Seatbelts.propTypes = iconPropTypes;

function Snacks(props) {
    return (
        <BaseIcon viewBox="0 0 16 16" {...props}>
            <title>{props.title || 'Snacks'}</title>
            <g>
                <path d="M11.54,13.12l-.71.71a4.12,4.12,0,0,1-2,1.09h0a4,4,0,0,1-1.6,0h0a4.12,4.12,0,0,1-2-1.09l-.7-.7.09-.1,1.32-1.32.72.7h0A1.93,1.93,0,0,0,8,13a2,2,0,0,0,1.39-.57l.73-.72L11.44,13Z" />
                <path d="M6.59,9.59,7.66,8.51,8,8.17l1-1,.39-.38,1.06-1.07.11-.11a2,2,0,1,1,2.83,2.83L13,8.88l1.42,1.42.46-.47a4,4,0,0,0,1-3.86A3.95,3.95,0,0,0,13,3.14a4,4,0,0,0-3.86,1l-.08.08L8,5.34,6.59,6.76l-.33.32-1,1.05-.09.09-.48.47-.89.9L2.34,11l-.52.52L1.3,12a1,1,0,0,0-.29.71,1,1,0,0,0,.25.66l.09.09a1,1,0,0,0,.66.25,1,1,0,0,0,.66-.25l.09-.09.34-.35.66-.65L4.14,12h0l1.79-1.79Z" />
                <path d="M1.63,10.29,3,8.88l-.47-.47A2,2,0,0,1,5.41,5.58L5.88,6,7.29,4.63l-.46-.46A4,4,0,0,0,3,3.14,3.95,3.95,0,0,0,.14,6a4,4,0,0,0,1,3.86Z" />
                <path d="M14.14,11.48,13.66,11,12.25,9.59,10.12,7.46l-.1.1L8.71,8.88l.7.71.48.47.94.94,1,1,.39.39.47.47.62.62a1,1,0,0,0,.66.25,1,1,0,0,0,1-1,1,1,0,0,0-.29-.71Z" />
            </g>
        </BaseIcon>
    );
}

Snacks.propTypes = iconPropTypes;

function USBPower(props) {
    return (
        <BaseIcon viewBox="0 0 16 16" {...props}>
            <title>{props.title || 'USB Power'}</title>
            <g>
                <path d="M10.5,3.4,9,6h1V8H8V3H9L7.5.4,6,3H7v7H5V7H6L4.5,4.4,3,7H4v4H7v1.09a1.5,1.5,0,1,0,1,0V9h3V6h1Z" />
            </g>
        </BaseIcon>
    );
}

USBPower.propTypes = iconPropTypes;

function Water(props) {
    return (
        <BaseIcon viewBox="0 0 16 16" {...props}>
            <title>{props.title || 'Water'}</title>
            <g>
                <path d="M8,2S4,6,4,10a4,4,0,0,0,8,0C12,6,8,2,8,2Z" />
            </g>
        </BaseIcon>
    );
}

Water.propTypes = iconPropTypes;

function Wifi(props) {
    return (
        <BaseIcon viewBox="0 0 16 16" {...props}>
            <title>{props.title || 'Wifi'}</title>
            <g>
                <path d="M.22,6.22,1.64,7.63a9,9,0,0,1,12.73,0l1.41-1.41A11,11,0,0,0,.22,6.22Z" />
                <path d="M3.05,9l1.41,1.41a5,5,0,0,1,7.07,0L12.95,9A7,7,0,0,0,3.05,9Z" />
                <path d="M5.88,11.87,7,13H7l1,1,1-1H9l1.13-1.13A3.07,3.07,0,0,0,5.88,11.87Z" />
            </g>
        </BaseIcon>
    );
}

Wifi.propTypes = iconPropTypes;

function Line(props) {
    return (
        <BaseIcon {...props}>
            {props.title && <title>{props.title}</title>}
            <rect height="100%" rx="1" width="100%" />
        </BaseIcon>
    );
}

Line.propTypes = iconPropTypes;

function CaretRight(props) {
    return (
        <BaseIcon viewBox={'0 0 6 10'} {...props}>
            {props.title && <title>{props.title}</title>}
            <path d="M1 1L5 5L1 9V1Z" strokeLinejoin="round" strokeWidth="2" />
        </BaseIcon>
    );
}

CaretRight.propTypes = iconPropTypes;

function Circle(props) {
    return (
        <BaseIcon viewBox={'0 0 6 6'} {...props}>
            {props.title && <title>{props.title}</title>}
            <circle cx="3" cy="3" r="3" />
        </BaseIcon>
    );
}

Circle.propTypes = iconPropTypes;

function CloseX(props) {
    return (
        <BaseIcon viewBox={'0 0 24 24'} {...props}>
            <title>{props.title || 'Close'}</title>
            <circle cx="12" cy="12" fill="#B6BDC7" r="12" />
            <path clipRule="evenodd" d="M17.6569 6.34313C18.2426 6.92892 18.2426 7.87866 17.6569 8.46445L8.46446 17.6568C7.87868 18.2426 6.92893 18.2426 6.34314 17.6568C5.75736 17.0711 5.75736 16.1213 6.34314 15.5355L15.5355 6.34313C16.1213 5.75734 17.0711 5.75734 17.6569 6.34313Z" fill="white" fillRule="evenodd" />
            <path clipRule="evenodd" d="M17.6569 17.6569C17.0711 18.2426 16.1213 18.2426 15.5355 17.6569L6.34316 8.46446C5.75738 7.87868 5.75738 6.92893 6.34316 6.34314C6.92895 5.75736 7.8787 5.75736 8.46448 6.34314L17.6569 15.5355C18.2427 16.1213 18.2427 17.0711 17.6569 17.6569Z" fill="white" fillRule="evenodd" />
        </BaseIcon>
    );
}

CloseX.propTypes = iconPropTypes;

function Moon(props) {
    return (
        <BaseIcon height="16" viewBox={'0 0 16 16'} width="16" {...props}>
            {props.title && <title>{props.title}</title>}
            <path clipRule="evenodd" d="M15.1879 11.0926C15.3704 10.7201 15.0025 10.3369 14.5959 10.4192C14.0802 10.5236 13.5465 10.5784 13 10.5784C8.58172 10.5784 5 6.99667 5 2.57839C5 2.0308 5.05502 1.49605 5.15983 0.979385C5.24229 0.572862 4.85921 0.204762 4.48667 0.387165C1.82964 1.68807 0 4.41858 0 7.57642C0 11.9947 3.58172 15.5764 8 15.5764C11.1567 15.5764 13.8864 13.7481 15.1879 11.0926Z" fillRule="evenodd" />
        </BaseIcon>
    );
}

Moon.propTypes = iconPropTypes;

function Bus(props) {
    return (
        <BaseIcon height="16.73" viewBox="4 9 24 14" width="26" xmlns="http://www.w3.org/2000/svg" {...props}>
            {props.title && <title>{props.title}</title>}
            <g clipPath="url(#clip0_19_3038)">
                <path d="M5.76378 9.62354H26.2363C26.7218 9.62354 27.1628 9.82191 27.4822 10.1413C27.8017 10.4608 28 10.9019 28 11.3873V18.5907C28 19.0761 27.8016 19.5171 27.4822 19.8366C27.1859 20.1329 26.7849 20.325 26.341 20.3513C26.3481 20.2705 26.3517 20.1891 26.3517 20.1072C26.3517 19.3707 26.0613 18.6697 25.5406 18.1491C25.0199 17.6284 24.319 17.3379 23.5825 17.3379C22.846 17.3379 22.1451 17.6284 21.6244 18.1491C21.1037 18.6697 20.8132 19.3707 20.8132 20.1072C20.8132 20.1901 20.817 20.2726 20.8242 20.3545H11.1758C11.183 20.2726 11.1868 20.1901 11.1868 20.1072C11.1868 19.3707 10.8963 18.6697 10.3756 18.1491C9.85496 17.6284 9.15399 17.3379 8.41752 17.3379C7.68102 17.3379 6.98009 17.6284 6.45941 18.1491C6.12065 18.4878 5.87939 18.9029 5.75213 19.3543C5.74626 19.3752 5.74063 19.3961 5.73526 19.417C5.67794 19.6403 5.64827 19.8719 5.64827 20.1072C5.64827 20.1891 5.6519 20.2705 5.65899 20.3513C5.21511 20.325 4.81411 20.133 4.51777 19.8366C4.19837 19.5172 4 19.0762 4 18.5907V11.3873C4 10.9017 4.19828 10.4607 4.51771 10.1412C4.83713 9.82181 5.27819 9.62354 5.76376 9.62354L5.76378 9.62354ZM27 17.827V16.8269H25.6771C25.4009 16.8269 25.177 17.0508 25.177 17.3269C25.177 17.6031 25.4009 17.827 25.6771 17.827H27ZM27 15.6096V11.3873H5.00003V15.6096H27Z" />
                <path d="M4.5 11.2664H27.5V12.2664H4.5V11.2664Z" />
                <path d="M4.5 14.8049H27.5V15.805H4.5V14.8049Z" />
                <path d="M8.06221 11.7664V15.3049H7.06219V11.7664H8.06221Z" />
                <path d="M11.066 11.7664V15.3049H10.066V11.7664H11.066Z" />
                <path d="M14.0697 11.7664V15.3049H13.0697V11.7664H14.0697Z" />
                <path d="M17.0735 11.7664V15.3049H16.0735V11.7664H17.0735Z" />
                <path d="M20.0772 11.7664V15.3049H19.0772V11.7664H20.0772Z" />
                <path d="M23.0811 11.7664V15.3049H22.081V11.7664H23.0811Z" />
                <path d="M23.5825 17.8379C24.2091 17.8379 24.7764 18.0919 25.1871 18.5026C25.5978 18.9132 25.8518 19.4806 25.8518 20.1071C25.8518 20.7337 25.5978 21.301 25.1871 21.7117C24.7764 22.1224 24.2091 22.3764 23.5825 22.3764C22.956 22.3764 22.3886 22.1224 21.978 21.7117C21.5673 21.301 21.3133 20.7337 21.3133 20.1071C21.3133 19.4806 21.5673 18.9132 21.978 18.5026C22.3887 18.0919 22.956 17.8379 23.5825 17.8379Z" />
                <path d="M8.4175 17.8379C9.04404 17.8379 9.61139 18.0919 10.0221 18.5026C10.4327 18.9132 10.6867 19.4806 10.6867 20.1071C10.6867 20.7337 10.4327 21.301 10.0221 21.7117C9.61139 22.1224 9.04407 22.3764 8.4175 22.3764C7.79093 22.3764 7.22361 22.1224 6.81294 21.7117C6.40227 21.301 6.14825 20.7337 6.14825 20.1071C6.14825 19.4806 6.40227 18.9132 6.81294 18.5026C7.22361 18.0919 7.79093 17.8379 8.4175 17.8379Z" />
            </g>
        </BaseIcon>
    );
}

Bus.propTypes = iconPropTypes;

function Train(props) {
    return (
        <BaseIcon height="23.66" viewBox="10 3 12.50 25" width="20.41" xmlns="http://www.w3.org/2000/svg" {...props}>
            {props.title && <title>{props.title}</title>}
            <g clipPath="url(#clip0_19_3037)">
                <path d="M11.7784 21.4923C11.9224 21.242 11.786 20.9456 11.4737 20.8302C11.1615 20.7148 10.7915 20.8241 10.6475 21.0743L7.05708 27.2909C6.91306 27.5412 7.04946 27.8376 7.36174 27.953C7.67403 28.0684 8.04395 27.9591 8.18798 27.7089L11.7784 21.4923Z" />
                <path d="M20.7543 21.0743C20.6103 20.8241 20.2404 20.7148 19.9281 20.8302C19.6158 20.9456 19.4794 21.242 19.6234 21.4923L23.2138 27.7089C23.3579 27.9591 23.7278 28.0684 24.0401 27.953C24.3523 27.8376 24.4887 27.5412 24.3447 27.2909L20.7543 21.0743Z" />
                <path d="M9.41773 22.222C9.07314 22.222 8.79376 22.4459 8.79376 22.7221C8.79376 22.9982 9.07314 23.2221 9.41773 23.2221H22.5825C22.9271 23.2221 23.2065 22.9982 23.2065 22.7221C23.2065 22.4459 22.9271 22.222 22.5825 22.222H9.41773Z" />
                <path d="M8.22089 23.6604C7.8763 23.6604 7.59692 23.8843 7.59692 24.1604C7.59692 24.4365 7.8763 24.6604 8.22089 24.6604H23.7793C24.1239 24.6604 24.4033 24.4365 24.4033 24.1604C24.4033 23.8843 24.1239 23.6604 23.7793 23.6604H8.22089Z" />
                <path d="M7.02399 25.5789C6.6794 25.5789 6.40002 25.8027 6.40002 26.0789C6.40002 26.355 6.6794 26.5789 7.02399 26.5789H24.976C25.3206 26.5789 25.6 26.355 25.6 26.0789C25.6 25.8027 25.3206 25.5789 24.976 25.5789H7.02399Z" />
                <path clipRule="evenodd" d="M23.2065 19.9779V5.68529C23.2065 5.23498 22.9985 4.82141 22.6635 4.51803C22.3105 4.19836 21.8187 3.99988 21.2735 3.99988H10.7267C10.1815 3.99988 9.68973 4.19832 9.33671 4.51801C9.00172 4.82137 8.79376 5.23493 8.79376 5.6853V19.9779C8.79376 20.4283 9.00174 20.8418 9.33673 21.1452C9.6013 21.3848 9.94375 21.5562 10.3282 21.6272C10.4568 21.6509 10.5901 21.6634 10.7267 21.6634H11.6796H19.7223H21.0946H21.2735C21.8187 21.6634 22.3104 21.4649 22.6635 21.1452C22.9985 20.8418 23.2065 20.4282 23.2065 19.9779L23.2065 19.9779ZM10.0417 8.12407H21.9585V12.8843L20.6247 13.3799H11.3587L10.0417 12.8865V8.12406L10.0417 8.12407ZM13.7332 17.4999V19.4999H12.4853V17.4999H13.7332ZM19.8579 17.4999V19.4999H18.6099V17.4999H19.8579ZM16.0001 4.77289C16.4133 4.77289 16.785 4.92244 17.052 5.16422C17.3065 5.39476 17.464 5.70954 17.464 6.05387C17.464 6.3982 17.3065 6.71298 17.052 6.94351C16.785 7.18529 16.4133 7.33485 16.0001 7.33485C15.587 7.33485 15.2152 7.18527 14.9483 6.94351C14.6937 6.71298 14.5362 6.39818 14.5362 6.05387C14.5362 5.70956 14.6937 5.39476 14.9483 5.16422C15.2152 4.92246 15.587 4.77289 16.0001 4.77289Z" fillRule="evenodd" />
            </g>
        </BaseIcon>
    );
}

Train.propTypes = iconPropTypes;

function Auto(props) {
    return (
        <BaseIcon height="17" viewBox="6 10 28 19" width="28" xmlns="http://www.w3.org/2000/svg" {...props}>
            {props.title && <title>{props.title}</title>}
            <g clipPath="url(#clip0_19_2980)">
                <path d="M11.0682 22.2783C11.8314 22.2783 12.5225 22.5878 13.0228 23.088C13.523 23.5883 13.8325 24.2794 13.8325 25.0426C13.8325 25.8059 13.523 26.497 13.0228 26.9972C12.5225 27.4975 11.8314 27.8069 11.0682 27.8069C10.3049 27.8069 9.61381 27.4975 9.1136 26.9972C8.61333 26.497 8.30389 25.8059 8.30389 25.0426C8.30389 24.2794 8.61333 23.5883 9.1136 23.088C9.61381 22.5878 10.3049 22.2783 11.0682 22.2783Z" />
                <path d="M28.9319 22.2783C29.6951 22.2783 30.3862 22.5878 30.8864 23.088C31.3867 23.5883 31.6961 24.2794 31.6961 25.0426C31.6961 25.8059 31.3867 26.497 30.8864 26.9972C30.3862 27.4975 29.6951 27.8069 28.9319 27.8069C28.1686 27.8069 27.4775 27.4975 26.9772 26.9972C26.477 26.497 26.1675 25.8059 26.1675 25.0426C26.1675 24.2794 26.477 23.5883 26.9772 23.088C27.4775 22.5878 28.1686 22.2783 28.9319 22.2783Z" />
                <path d="M7.20469 17.2549H32.7953C33.3778 17.2549 33.9142 17.4591 34.3089 17.7881C34.7353 18.1434 35 18.6414 35 19.1963V22.8822C35 23.4371 34.7353 23.9351 34.3089 24.2904C33.9141 24.6194 33.3778 24.8236 32.7953 24.8236H32.3141C32.2614 24.0031 31.9138 23.2315 31.3284 22.646C30.6911 22.0088 29.8332 21.6532 28.9318 21.6532C28.0304 21.6532 27.1726 22.0087 26.5353 22.646C26.262 22.9193 26.0406 23.2331 25.8768 23.5736L14.1231 23.5736C14.3103 23.9625 14.4222 24.3861 14.4503 24.8236H25.5496C25.5777 24.3861 25.6896 23.9625 25.8768 23.5736H14.1232C13.9593 23.2331 13.7379 22.9193 13.4647 22.646C12.8274 22.0088 11.9695 21.6532 11.0681 21.6532C10.1667 21.6532 9.30887 22.0087 8.67162 22.646C8.39837 22.9193 8.17696 23.2331 8.01313 23.5736L7.20467 23.5736H8.01313C7.82598 23.9625 7.71402 24.3861 7.68593 24.8236H7.20467C6.62219 24.8236 6.08583 24.6194 5.69108 24.2904C5.26471 23.9351 5 23.4371 5 22.8822V19.1963C5 18.6414 5.26466 18.1434 5.69108 17.7881C6.08583 17.4591 6.62215 17.2549 7.20467 17.2549L7.20469 17.2549ZM33.75 20.9375V19.6874H31.875C31.5299 19.6874 31.25 19.9673 31.25 20.3124C31.25 20.6576 31.5299 20.9375 31.875 20.9375H33.75ZM6.25 19.1963V22.8822L6.25002 20.9375H8.12498C8.47015 20.9375 8.74999 20.6576 8.74999 20.3124C8.74999 19.9673 8.47015 19.6874 8.12498 19.6874H6.25002L6.25 19.1963Z" />
                <path d="M7.64375 17.4771C7.42128 17.7387 7.45298 18.1311 7.71455 18.3536C7.97612 18.5761 8.36857 18.5444 8.59104 18.2828L13.2416 12.8182H22.4073L28.5989 18.1349C28.8604 18.3587 29.254 18.3281 29.4778 18.0665C29.7016 17.8049 29.671 17.4114 29.4094 17.1876L23.0765 11.7495C22.9635 11.6374 22.808 11.5681 22.6362 11.5681H12.957V11.5682C12.7802 11.5683 12.6046 11.6429 12.481 11.7881L12.957 12.1931L12.4834 11.7903L7.64374 17.4771L7.64375 17.4771Z" />
                <path d="M19.1858 12.3408V17.8799H17.9358V12.3408H19.1858Z" />
            </g>
        </BaseIcon>
    );
}

Auto.propTypes = iconPropTypes;

function Flight(props) {
    return (
        <BaseIcon height="28" viewBox="5 9 30 20" width="28" xmlns="http://www.w3.org/2000/svg" {...props}>
            {props.title && <title>{props.title}</title>}
            <g clipPath="url(#clip0_19_2976)">
                <path d="M20.515 31.5625C20.515 31.2173 20.2352 30.9375 19.89 30.9375C19.5449 30.9375 19.265 31.2173 19.265 31.5625V34.0625C19.265 34.4077 19.5449 34.6875 19.89 34.6875C20.2352 34.6875 20.515 34.4077 20.515 34.0625V31.5625Z" />
                <path d="M22.2881 7.4308C22.4082 7.70407 22.5104 7.99245 22.5973 8.29449C21.6802 8.02599 20.7608 7.88926 19.839 7.88765C18.9545 7.88611 18.0709 8.0095 17.1884 8.26069C17.2705 7.96537 17.3662 7.6826 17.4778 7.41396C17.7781 6.69128 18.1472 6.16289 18.5523 5.81966C18.9579 5.47594 19.4015 5.31095 19.8573 5.31501C20.3075 5.31903 20.7444 5.48888 21.1441 5.81488C21.5784 6.16921 21.9729 6.7137 22.2881 7.4308H22.2881ZM19.839 8.51022C33.7448 8.53497 6.19765 8.48607 19.839 8.51022V8.51022Z" />
                <path d="M16.2449 21.5996C15.5781 21.7746 14.8475 21.9927 14.0574 22.251C12.6367 22.7156 11.048 23.3017 9.31348 23.9933C8.81959 24.2422 8.40032 24.3503 8.05533 24.3187C7.5358 24.2711 7.20777 23.9855 7.06989 23.4637L7.05035 23.3465C7.01951 22.8877 7.00954 22.4398 7.0838 22.0361C7.17241 21.5543 7.37499 21.152 7.77341 20.8861L8.58634 20.1964L8.64493 20.1524L16.1129 15.1978L16.113 15.2049C16.1242 15.9186 16.1329 16.6317 16.1329 17.3456C16.1329 18.7631 16.1677 20.1831 16.2449 21.5996L16.2449 21.5996Z" />
                <path d="M23.6606 15.0474L31.3551 20.1524L31.4137 20.1963L32.2267 20.886C32.6251 21.1519 32.8277 21.5543 32.9163 22.036C32.9905 22.4397 32.9806 22.8876 32.9497 23.3465L32.9302 23.4637C32.7923 23.9855 32.4643 24.271 31.9447 24.3186C31.5998 24.3503 31.1805 24.2421 30.6866 23.9932C28.952 23.3016 27.3634 22.7156 25.9427 22.251C25.0604 21.9625 24.2522 21.7241 23.5243 21.5401C23.5992 20.1433 23.633 18.7432 23.633 17.3455C23.633 16.5863 23.6454 15.8281 23.6601 15.0691L23.6606 15.0474L23.6606 15.0474Z" />
                <path d="M17.8242 30.9813C17.6926 31.0756 17.5561 31.1755 17.4205 31.2748C16.9555 31.6153 16.4989 31.9496 16.1468 32.1164C15.608 32.3717 15.1843 32.336 14.9439 31.8286L14.9049 31.7163C14.6793 30.8373 15.0967 29.888 15.7126 29.0277C16.0707 28.5274 16.4986 28.0522 16.8905 27.6488C17.0289 28.4322 17.3019 29.8351 17.8242 30.9813L17.8242 30.9813Z" />
                <path d="M22.84 27.8457C23.1772 28.2034 23.528 28.6067 23.8294 29.0277C24.4453 29.888 24.8627 30.8373 24.6371 31.7163L24.5981 31.8286C24.3578 32.336 23.934 32.3717 23.3952 32.1164C23.0431 31.9496 22.5865 31.6153 22.1215 31.2748C22.0426 31.217 21.9634 31.159 21.8851 31.1021C22.4016 30.0244 22.6866 28.6835 22.84 27.8457V27.8457Z" />
                <path clipRule="evenodd" d="M22.266 27.5058C22.7244 24.8987 23.008 21.3059 23.008 17.3454C23.008 16.4555 23.0218 15.7489 23.0352 15.0568C23.0785 12.8304 23.1192 10.735 22.7689 9.00231C21.7893 8.67744 20.8126 8.51187 19.8389 8.51015C18.9014 8.50848 17.9625 8.65797 17.0223 8.9625C16.6685 10.7435 16.7022 12.9005 16.738 15.195C16.7479 15.827 16.758 16.471 16.758 17.3454C16.758 21.3059 17.0416 24.8987 17.5 27.5058C17.9034 29.7999 18.5118 31.3999 19.265 31.9638C19.4615 32.1109 19.6679 32.1875 19.883 32.1875C20.1033 32.1875 20.3143 32.1072 20.515 31.9532C21.2618 31.38 21.8651 29.7857 22.266 27.5058H22.266ZM21.765 24.9999V23.9115L22.39 24.0476V24.8638L21.765 24.9999ZM21.765 23.1249V22.0365L22.39 22.1726V22.9888L21.765 23.1249ZM21.765 21.2499V20.1615L22.39 20.2976V21.1138L21.765 21.2499ZM21.765 19.3749V18.2865L22.39 18.4226V19.2388L21.765 19.3749V19.3749ZM22.39 17.3638L21.765 17.4999V16.4115L22.39 16.5476V17.3638V17.3638ZM22.39 15.4888L21.765 15.6249V14.5365L22.39 14.6726V15.4888ZM22.39 13.6138L21.765 13.7499V12.6615L22.39 12.7976V13.6138ZM22.39 11.7388L21.765 11.8749V10.7865L22.39 10.9226V11.7388V11.7388ZM18.015 23.9115V24.9999L17.39 24.8638V24.0476L18.015 23.9115ZM18.015 22.0365V23.1249L17.39 22.9888V22.1726L18.015 22.0365ZM18.015 20.1615V21.2499L17.39 21.1138V20.2976L18.015 20.1615ZM18.015 18.2865V19.3749L17.39 19.2388V18.4226L18.015 18.2865ZM18.015 17.4999L17.39 17.3638V16.5476L18.015 16.4115V17.4999V17.4999ZM18.015 15.6249L17.39 15.4888V14.6726L18.015 14.5365V15.6249ZM18.015 13.7499L17.39 13.6138V12.7976L18.015 12.6615V13.7499ZM18.015 11.8749L17.39 11.7388V10.9226L18.015 10.7865V11.8749V11.8749Z" fillRule="evenodd" />
            </g>
        </BaseIcon>
    );
}

Flight.propTypes = iconPropTypes;

function Ferry(props) {
    return (
        <BaseIcon height="20" viewBox="5 10 30 19" width="30" xmlns="http://www.w3.org/2000/svg" {...props}>
            {props.title && <title>{props.title}</title>}
            <g clipPath="url(#clip0_19_2977)">
                <path d="M11.0632 14.6289V12.1405C11.0632 11.9544 11.4202 11.7854 11.9953 11.6631C12.5704 11.5408 13.3648 11.4648 14.2395 11.4648H17.1837C18.0584 11.4648 18.8528 11.5408 19.4279 11.6631C20.003 11.7855 20.36 11.9544 20.36 12.1405V14.6289H11.0632L11.0632 14.6289Z" />
                <path clipRule="evenodd" d="M18.0301 23.8847C17.6285 23.8847 17.3029 23.5592 17.3029 23.1576C17.3029 22.7561 17.6285 22.4305 18.0301 22.4305C18.4316 22.4305 18.7572 22.7561 18.7572 23.1576C18.7572 23.5592 18.4316 23.8847 18.0301 23.8847ZM34.3051 20.2538H24.4618H6.96176H5.71178H4.88281L5.11363 21.0521L6.67611 26.4558C6.8431 27.0334 7.15173 27.5771 7.61792 27.9655C8.03908 28.3165 8.5733 28.5351 9.22736 28.5351H30.7895C31.4434 28.5351 31.9777 28.3165 32.3989 27.9655C32.8651 27.577 33.1738 27.0332 33.3407 26.4558L34.9032 21.0521L35.134 20.2538H34.305L34.3051 20.2538ZM25.2182 23.8847C24.8167 23.8847 24.4911 23.5592 24.4911 23.1576C24.4911 22.7561 24.8167 22.4305 25.2182 22.4305C25.6198 22.4305 25.9453 22.7561 25.9453 23.1576C25.9453 23.5592 25.6198 23.8847 25.2182 23.8847ZM27.6143 23.8847C27.2127 23.8847 26.8872 23.5592 26.8872 23.1576C26.8872 22.7561 27.2127 22.4305 27.6143 22.4305C28.0159 22.4305 28.3414 22.7561 28.3414 23.1576C28.3414 23.5592 28.0159 23.8847 27.6143 23.8847ZM29.2832 23.1576C29.2832 22.7561 29.6088 22.4305 30.0103 22.4305C30.4119 22.4305 30.7374 22.7561 30.7374 23.1576C30.7374 23.5592 30.4119 23.8847 30.0103 23.8847C29.6088 23.8847 29.2832 23.5592 29.2832 23.1576ZM31.6793 23.1576C31.6793 22.7561 32.0048 22.4305 32.4064 22.4305C32.808 22.4305 33.1335 22.7561 33.1335 23.1576C33.1335 23.5592 32.808 23.8847 32.4064 23.8847C32.0048 23.8847 31.6793 23.5592 31.6793 23.1576ZM20.4261 23.8847C20.0246 23.8847 19.699 23.5592 19.699 23.1576C19.699 22.7561 20.0246 22.4305 20.4261 22.4305C20.8277 22.4305 21.1532 22.7561 21.1532 23.1576C21.1532 23.5592 20.8277 23.8847 20.4261 23.8847ZM22.0951 23.1576C22.0951 22.7561 22.4206 22.4305 22.8222 22.4305C23.2238 22.4305 23.5493 22.7561 23.5493 23.1576C23.5493 23.5592 23.2238 23.8847 22.8222 23.8847C22.4206 23.8847 22.0951 23.5592 22.0951 23.1576ZM15.634 23.8847C15.2324 23.8847 14.9069 23.5592 14.9069 23.1576C14.9069 22.7561 15.2324 22.4305 15.634 22.4305C16.0356 22.4305 16.3611 22.7561 16.3611 23.1576C16.3611 23.5592 16.0356 23.8847 15.634 23.8847ZM13.238 23.8847C12.8364 23.8847 12.5109 23.5592 12.5109 23.1576C12.5109 22.7561 12.8364 22.4305 13.238 22.4305C13.6395 22.4305 13.965 22.7561 13.965 23.1576C13.965 23.5592 13.6395 23.8847 13.238 23.8847ZM11.569 23.1576C11.569 23.5592 11.2435 23.8847 10.8419 23.8847C10.4403 23.8847 10.1148 23.5592 10.1148 23.1576C10.1148 22.7561 10.4403 22.4305 10.8419 22.4305C11.2435 22.4305 11.569 22.7561 11.569 23.1576ZM8.44583 22.4305C8.84741 22.4305 9.17295 22.7561 9.17295 23.1576C9.17295 23.5592 8.84741 23.8847 8.44583 23.8847C8.04426 23.8847 7.71874 23.5592 7.71874 23.1576C7.71874 22.7561 8.04426 22.4305 8.44583 22.4305Z" fillRule="evenodd" />
                <path clipRule="evenodd" d="M16.9616 15.2539H15.3992H10.7116H7.58662H6.96161V15.8789V19.6289H24.4617V15.8789V15.2539H23.8367H21.2361H16.9616H16.9616ZM12.234 16.5331C12.4665 16.3006 12.7877 16.1568 13.1424 16.1568C13.497 16.1568 13.8182 16.3006 14.0507 16.5331C14.2832 16.7656 14.427 17.0868 14.427 17.4414C14.427 17.7961 14.2832 18.1173 14.0507 18.3498C13.8182 18.5822 13.497 18.7261 13.1424 18.7261C12.7877 18.7261 12.4665 18.5822 12.234 18.3498C12.0016 18.1173 11.8577 17.7961 11.8577 17.4414C11.8577 17.0868 12.0015 16.7656 12.234 16.5331ZM17.3725 16.5331C17.605 16.3006 17.9262 16.1568 18.2809 16.1568C18.6355 16.1568 18.9567 16.3006 19.1892 16.5331C19.4217 16.7656 19.5655 17.0868 19.5655 17.4414C19.5655 17.7961 19.4217 18.1173 19.1892 18.3498C18.9567 18.5822 18.6355 18.7261 18.2809 18.7261C17.9262 18.7261 17.605 18.5822 17.3725 18.3498C17.1401 18.1173 16.9962 17.7961 16.9962 17.4414C16.9962 17.0868 17.1401 16.7656 17.3725 16.5331Z" fillRule="evenodd" />
            </g>
        </BaseIcon>
    );
}

Ferry.propTypes = iconPropTypes;

function Shuttle(props) {
    return (
        <BaseIcon viewBox="0 0 20 11" width="26" xmlns="http://www.w3.org/2000/svg" {...props}>
            {props.title && <title>{props.title}</title>}
            <path d="M4.04501 7.14502C4.55501 7.14502 5.01501 7.35002 5.35001 7.68502C5.68501 8.02002 5.89001 8.48002 5.89001 8.99002C5.89001 9.50002 5.68501 9.96002 5.35001 10.295C5.01501 10.63 4.55501 10.835 4.04501 10.835C3.53501 10.835 3.07501 10.63 2.74001 10.295C2.40501 9.96002 2.20001 9.50002 2.20001 8.99002C2.20001 8.48002 2.40501 8.02002 2.74001 7.68502C3.07501 7.35002 3.53501 7.14502 4.04501 7.14502Z"/>
            <path d="M15.955 7.14502C16.465 7.14502 16.925 7.35002 17.26 7.68502C17.595 8.02002 17.8 8.48002 17.8 8.99002C17.8 9.50002 17.595 9.96002 17.26 10.295C16.925 10.63 16.465 10.835 15.955 10.835C15.445 10.835 14.985 10.63 14.65 10.295C14.315 9.96002 14.11 9.50002 14.11 8.99002C14.11 8.48002 14.315 8.02002 14.65 7.68502C14.985 7.35002 15.445 7.14502 15.955 7.14502Z"/>
            <path d="M0 5.29012V7.55012C0 7.92012 0.175 8.25012 0.46 8.49012C0.725 8.71012 1.08 8.84512 1.47 8.84512H1.79C1.81 8.55512 1.885 8.27012 2.01 8.01012C2.12 7.78512 2.265 7.57512 2.45 7.39012C2.875 6.96512 3.445 6.73012 4.05 6.73012C4.655 6.73012 5.225 6.96512 5.65 7.39012C5.83 7.57012 5.98 7.78012 6.09 8.01012C6.215 8.27012 6.29 8.55012 6.31 8.84512H13.71C13.73 8.55512 13.805 8.27012 13.93 8.01012C14.04 7.78512 14.185 7.57512 14.37 7.39012C14.795 6.96512 15.365 6.73012 15.97 6.73012C16.575 6.73012 17.145 6.96512 17.57 7.39012C17.96 7.78012 18.19 8.29512 18.225 8.84012H18.545C18.935 8.84012 19.29 8.70512 19.555 8.48512C19.84 8.25012 20.015 7.91512 20.015 7.54512V5.09012C20.015 4.72012 19.84 4.39012 19.555 4.15012C19.29 3.93012 18.935 3.79512 18.545 3.79512H17.825C17.825 3.79512 17.805 3.76512 17.79 3.75012L13.55 0.125122L13.425 0.00512213H1.175H1.1C0.5 -0.0398779 0.02 0.250122 0 0.560122M2.085 6.25012H0.835V5.41512H2.085C2.315 5.41512 2.5 5.60012 2.5 5.83012C2.5 6.06012 2.315 6.24512 2.085 6.24512V6.25012ZM10.125 3.19512C10.125 3.52512 9.86 3.79512 9.535 3.79512H1.275C0.95 3.79512 0.685 3.52512 0.685 3.19512V1.43512C0.685 1.10512 0.95 0.835122 1.275 0.835122H9.535C9.86 0.835122 10.125 1.10512 10.125 1.43512V3.19512ZM16.345 3.79512H11.475C11.19 3.79512 10.955 3.56012 10.955 3.27512V1.35512C10.955 1.07012 11.19 0.835122 11.475 0.835122H12.91C13.035 0.835122 13.15 0.880122 13.245 0.960122L16.39 3.66012C16.445 3.70512 16.41 3.79512 16.34 3.79512H16.345ZM19.165 6.25012H17.915C17.685 6.25012 17.5 6.06512 17.5 5.83512C17.5 5.60512 17.685 5.42012 17.915 5.42012H19.165V6.25512V6.25012Z"/>
        </BaseIcon>
    );
}

Shuttle.propTypes = iconPropTypes;

function ChevronUp(props) {
    return (
        <BaseIcon height="7" viewBox="0 0 10 7" width="10" {...props}>
            {props.title && <title>{props.title}</title>}
            <path d="M9 5.36377L5 1.00013L1 5.36377" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
        </BaseIcon>
    );
}

ChevronUp.propTypes = iconPropTypes;

function ChevronDown(props) {
    return (
        <BaseIcon height="7" viewBox="0 0 10 7" width="10" {...props}>
            {props.title && <title>{props.title}</title>}
            <path d="M1 1L5 5.36364L9 1" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
        </BaseIcon>
    );
}

ChevronDown.propTypes = iconPropTypes;

function ChevronLeft(props) {
    return (
        <BaseIcon height="24" viewBox="0 0 24 24" width="24" {...props}>
            {props.title && <title>{props.title}</title>}
            <path d="M16.5607 3.43934C17.1464 4.02513 17.1464 4.97488 16.5607 5.56066L10.6213 11.5L16.5607 17.4393C17.1464 18.0251 17.1464 18.9749 16.5607 19.5607C15.9749 20.1464 15.0251 20.1464 14.4393 19.5607L7.43934 12.5607C6.85355 11.9749 6.85355 11.0251 7.43934 10.4393L14.4393 3.43934C15.0251 2.85355 15.9749 2.85355 16.5607 3.43934Z" />
        </BaseIcon>
    );
}

ChevronLeft.propTypes = iconPropTypes;

function ChevronRight(props) {
    return (
        <BaseIcon height="24" viewBox="0 0 24 24" width="24" {...props}>
            {props.title && <title>{props.title}</title>}
            <path d="M7.43934 20.0605C6.85355 19.4747 6.85355 18.5249 7.43934 17.9392L13.3787 11.9998L7.43934 6.06048C6.85355 5.47469 6.85355 4.52495 7.43934 3.93916C8.02512 3.35337 8.97487 3.35337 9.56066 3.93916L16.5607 10.9392C17.1464 11.5249 17.1464 12.4747 16.5607 13.0605L9.56066 20.0605C8.97487 20.6463 8.02513 20.6463 7.43934 20.0605Z" />
        </BaseIcon>
    );
}

ChevronRight.propTypes = iconPropTypes;

function BigChevronUp(props) {
    return (
        <BaseIcon height="24" viewBox="0 0 24 24" width="24" {...props}>
            {props.title && <title>{props.title}</title>}
            <path clipRule="evenodd" d="M20.0607 16.5605C19.4749 17.1463 18.5251 17.1463 17.9393 16.5605L12 10.6211L6.06066 16.5605C5.47487 17.1463 4.52513 17.1463 3.93934 16.5605C3.35355 15.9747 3.35355 15.0249 3.93934 14.4392L10.9393 7.43916C11.5251 6.85337 12.4749 6.85337 13.0607 7.43916L20.0607 14.4392C20.6464 15.0249 20.6464 15.9747 20.0607 16.5605Z" fill="#414042" fillRule="evenodd" />
        </BaseIcon>
    );
}

BigChevronUp.propTypes = iconPropTypes;

function BigChevronDown(props) {
    return (
        <BaseIcon height="24" viewBox="0 0 24 24" width="24" {...props}>
            {props.title && <title>{props.title}</title>}
            <path clipRule="evenodd" d="M3.93934 7.43916C4.52513 6.85337 5.47487 6.85337 6.06066 7.43916L12 13.3785L17.9393 7.43916C18.5251 6.85337 19.4749 6.85337 20.0607 7.43916C20.6464 8.02494 20.6464 8.97469 20.0607 9.56048L13.0607 16.5605C12.4749 17.1463 11.5251 17.1463 10.9393 16.5605L3.93934 9.56048C3.35355 8.97469 3.35355 8.02494 3.93934 7.43916Z" fill="#414042" fillRule="evenodd" />
        </BaseIcon>
    );
}

BigChevronDown.propTypes = iconPropTypes;

export {
    AC,
    Attendant,
    Auto,
    BigChevronDown,
    BigChevronUp,
    Bus,
    CaretRight,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    Circle,
    CloseX,
    ExtraLegroom,
    Ferry,
    Flight,
    Games,
    Green,
    HotBeverage,
    Line,
    LoyaltyRewards,
    Meal,
    Moon,
    Movies,
    Newspaper,
    PowerOutlet,
    QRCode,
    Restroom,
    SatelliteTV,
    Seatbelts,
    Shuttle,
    Snacks,
    Train,
    USBPower,
    Water,
    Wifi,
};
